// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "beam-frontend_0.35.0_" + chunkId + ".bundle.js";
};